import { apiClient } from '@app/lib'
import { type ApiResponse } from '@app/types'
import { useMutation } from '@tanstack/react-query'

export const useVerifyPhoneNumber = () =>
  useMutation({
    mutationKey: ['verifyPhoneNumber'],
    mutationFn: async (code: string) => {
      const { data } = await apiClient.post<ApiResponse>(
        `/api/mfa/verify_phone_number`,
        {
          code
        },
        {
          validateStatus: () => true
        }
      )

      return data
    }
  })
